import script from "./ShoppingDetailPage1.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingDetailPage1.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingDetailPage1.vue?vue&type=style&index=0&id=4ef0e2c4&scoped=true&lang=scss"

import exportComponent from "D:\\java\\code\\overseas_code\\wlxf-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef0e2c4"]])

export default __exports__